// Version : 1.0.0
// Author : AGALYA
import NomineeDetailsActionType from './basic-nominee-details.types';

/** ***************** NOMINEE DETAILS ADD START *********************** */

export const nomineeDetailsAddStart = (nomineeDetailsCredentials: any) => ({
	type: NomineeDetailsActionType.NOMINEE_DETAILS_ADD_START,
	payload: nomineeDetailsCredentials,
});

export const nomineeDetailsAddSuccess = (nomineeDetailsSuccess: any) => ({
	type: NomineeDetailsActionType.NOMINEE_DETAILS_ADD_SUCCESS,
	payload: nomineeDetailsSuccess,
});

export const nomineeDetailsAddFailure = (nomineeDetailsFailure: unknown) => ({
	type: NomineeDetailsActionType.NOMINEE_DETAILS_ADD_FAILURE,
	payload: nomineeDetailsFailure,
});

export const nomineeDetailsAddResponseResetStart = () => ({
	type: NomineeDetailsActionType.NOMINEE_DETAILS_ADD_RESPONSE_REST_START,
});

export const nomineeDetailsAddUserResponseChanged = () => ({
	type: NomineeDetailsActionType.NOMINEE_DETAILS_ADD_RESPONSE_CHANGED,
});
/** ***************** NOMINEE DETAILS ADD END *********************** */
